// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../Images/emp-logo-animation.svg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div id=\"loading-container\" class=\"fixed top-0 left-0 z-20 w-full h-full bg-gray-100 flex justify-center items-center\"> <div class=\"m-auto p-20 flex flex-col items-center\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" class=\"mb-20 w-128 h-128\"/> </div> </div>";
// Exports
module.exports = code;